import React from "react";

const LinkedinSocialIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.16523 8.32036H7.23799V15H5.16523V8.32036ZM6.20206 5C6.52056 5.0003 6.82591 5.1272 7.05107 5.35283C7.27624 5.57845 7.40281 5.88436 7.40299 6.20339C7.40293 6.52249 7.27641 6.82852 7.05123 7.05424C6.82606 7.27997 6.52063 7.40693 6.20206 7.40723C5.8833 7.40723 5.57758 7.28041 5.35216 7.05465C5.12673 6.82889 5.00006 6.52269 5 6.20339C5.00018 5.88417 5.12691 5.57808 5.35232 5.35242C5.57773 5.12676 5.88338 5 6.20206 5ZM8.53764 8.32036H10.5254V9.23074H10.5528C10.827 8.70562 11.5058 8.15188 12.5136 8.15188C14.6124 8.15188 15 9.53542 15 11.3338V14.9975H12.9293V11.7469C12.9293 10.9723 12.9151 9.97585 11.8522 9.97585C10.7736 9.97585 10.6083 10.8196 10.6083 11.6909V14.9952H8.53786V8.31555L8.53764 8.32036Z",
  fill: "#0A66C2"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LinkedinSocialIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;